"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $dyn;
(function ($dyn) {
    var ax;
    (function (ax) {
        var taskGuide;
        (function (taskGuide) {
            /**  Used in the task guide chain to prepare the guidedStepModel (an object passed between the components in the task guide chain). */
            var QTipComponent = /** @class */ (function () {
                function QTipComponent(controller) {
                    var _this = this;
                    this.controller = controller;
                    this.dispose = function () {
                        var e_1, _a;
                        try {
                            for (var _b = __values(_this.subscriptions), _c = _b.next(); !_c.done; _c = _b.next()) {
                                var subscription = _c.value;
                                if (subscription && subscription.dispose) {
                                    subscription.dispose();
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        _this.subscriptions = null;
                    };
                    this.subscriptions = [];
                }
                QTipComponent.prototype.setup = function (input, output) {
                    var _this = this;
                    this.input = input;
                    this.output = output;
                    this.subscriptions.push($dyn.observe(input, function (guidedStepModel) {
                        _this.output(_this._updateQTipPosition(guidedStepModel));
                    }));
                };
                QTipComponent.prototype._updateQTipPosition = function (guidedStepModel) {
                    if (!guidedStepModel) {
                        return;
                    }
                    if (this.controller.testFlag) {
                        return guidedStepModel;
                    }
                    var options = guidedStepModel.options;
                    options.target = $(options.target);
                    options.shadowTarget = $(options.shadowTarget);
                    var mainPane = $("#mainPane");
                    var stackContainer = $("#" + $dyn.shell.stackContainerId);
                    // If no target is provided convert this to a shell level info tip
                    if (!options.target || !options.target[0]) {
                        $.extend(options, {
                            adjust: {
                                x: -10,
                                y: stackContainer.offset().top - mainPane.offset().top + 10
                            },
                            at: $dyn.layout.qTipPosition.topRight,
                            my: $dyn.layout.qTipPosition.topRight,
                            shadowTarget: null,
                            styles: {
                                hideTip: true
                            },
                            target: mainPane
                        });
                    }
                    return { options: options, content: guidedStepModel.content };
                };
                return QTipComponent;
            }());
            taskGuide.QTipComponent = QTipComponent;
        })(taskGuide = ax.taskGuide || (ax.taskGuide = {}));
    })(ax = $dyn.ax || ($dyn.ax = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=QTipComponent.js.map
